import {createNavigationContainerRef} from '@react-navigation/native';
import {appScreen} from 'constant/appScreen';
import * as React from 'react';

export const navigationRef = createNavigationContainerRef<any>();
const timeoutref: any = React.createRef();

export function navigate(
  name: appScreen,
  params?: object,
  cancelDebounce?: boolean,
) {
  return new Promise((rs, rj) => {
    if (name == 'AlertModal') {
      navigationRef.current?.navigate(name, params);
      rs('');
      return;
    }
    // if (timeoutref.current && !cancelDebounce) {
    //   return;
    // }
    if (__DEV__) {
      console.log('SCEEN:', name);
    }
    navigationRef.current?.navigate(name, params);
    rs('');
    return '';
  });
  // timeoutref.current = setTimeout(() => {
  //   clearTimeout(timeoutref.current);
  //   timeoutref.current = null;
  // }, 0);
}
export function goBack() {
  return new Promise((rs, rj) => {
    if (navigationRef.current) {
      navigationRef.current?.goBack();
    }
    rs('');
    return '';
  });
}

type TabName =
  | 'OverviewScreen'
  | 'TransactionScreen'
  | 'InvestmentScreen'
  | 'AssetScreen'
  | 'ProfileScreen';

export function resetToTab(tabName: TabName, params?: object) {
  navigationRef.current?.reset({
    index: 0,
    routes: [
      {
        name: 'TabContainer',
        state: {
          index: 0,
          routes: [
            {
              name: tabName,
              params,
            },
          ],
        },
      },
    ],
  });
}

export function navigateReset(name: appScreen) {
  navigationRef.current?.reset({
    index: 0,
    routes: [{name}],
  });
}
